export enum KickoffMasteryTrackingEvents {
  CourseStarted = 'course_started', // FIXME: duplicate with CourseEvents.CourseStarted
  ActivityAccepted = 'activity_accepted',
  KickoffStarted = 'kickoff_started', // FIXME: duplicate with ActivityEvents.KickoffQuizStarted
  LearningStarted = 'learning_started', // FIXME: potential duplicate
  KickoffTabOpened = 'kickoff_tab_opened',
  ComparisonExpertVideoOpened = 'comparison_expert_video_opened',
}

export enum KickoffMasteryTrackingParameters {
  CourseStartSource = 'course_start_source',
}

export enum KickoffMasteryTrackingValues {
  StartLearningButton = 'start_learning_button',
  LessonsList = 'lessons_list',
}

export const KickoffTabHitCountKey = 'kickoff_tab_hit_count';